import BaseApi from './baseApi';
import { API_BASE_URL, USER_ENDPOINTS } from './endpoints';
import { User } from './types';


class UserApi extends BaseApi {
  constructor() {
    super(API_BASE_URL);
  }

  async getUserInfo(): Promise<User> {
    return this.get<User>(USER_ENDPOINTS.ME);
  }

  async acceptTermsAndConditions(userId: string): Promise<User> {
    const requestData = {
      has_accepted_terms_and_conditions: true,
      datetime_last_accepted_terms_and_conditions: new Date().toISOString()
    };

    console.log('Sending PATCH request to:', USER_ENDPOINTS.UPDATE_USER(userId));
    console.log('Request data:', requestData);
    try {
      const result = await this.patch<User>(USER_ENDPOINTS.UPDATE_USER(userId), requestData);
      console.log('Success response:', result);
      return result;
    } catch (error) {
      console.error('Error accepting terms - Full error object:', error);
      console.error('Error message:', error instanceof Error ? error.message : 'Unknown error');
      const axiosError = error as { response?: { data?: unknown; status?: number } };
      console.error('Error response:', axiosError?.response?.data);
      console.error('Error status:', axiosError?.response?.status);
      throw error;
    }
  }
}

export const userApi = new UserApi();